import { render } from "./SubCategories.vue?vue&type=template&id=4f8942e7&scoped=true"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"

import "./SubCategories.vue?vue&type=style&index=0&id=4f8942e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8942e7"]])

export default __exports__